export const getVersionNumber = () => {
  return process.env.REACT_APP_OPTILIFT_VERSION;
};
